import "./App.css";

import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

 import Navbar from "./components/Navbar";
 import CartPage from "./pages/CartPage";
// import Placeholder from './components/Placeholder'
 import ProductDetailPage from "./pages/ProductDetailPage";
 import ProductsPageAll from "./pages/ProductsPageAll";

function App() {
  return (
    <div id="app">
      { <Router>
        <Navbar />
        <Switch>
          <Route exact path="/">
            <ProductsPageAll />
          </Route>
          <Route exact path="/tops">
            <ProductsPageAll filter={"tops"} />
          </Route>
          <Route exact path="/bottoms">
            <ProductsPageAll filter={"Bottoms"} />
          </Route>
          <Route exact path="/shoes">
            <ProductsPageAll filter={"Shoes"} />
          </Route>
          <Route exact path="/cart">
            <CartPage />
          </Route>
          <Route exact path="/products/:id">
            <ProductDetailPage />
          </Route>
        </Switch>
      </Router> }
    </div>
  );
}

export default App;
